import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import pl from "./pl.json";
import en from "./en.json";
import de from "./de.json";
import fr from "./fr.json";
import no from "./no.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { pl: { translation: pl }, en: { translation: en }, de: { translation: de }, fr: { translation: fr }, no: { translation: no } },
    fallbackLng: "pl",
    interpolation: { escapeValue: false },
    detection: {
      order: ["querystring", "localStorage", "navigator"],
      lookupQuerystring: "lang",
      caches: ["localStorage"],
    },
  });

export default i18n;
